import type { FC, ReactNode } from "react";
import { useIsInsideInteractiveReference } from "./interactiveReferenceBoundary.js";

export interface CustomerReferenceNodeProps {
  className: string;
  children: ReactNode;
}

/**
 * Renders a customer reference from the AST as styled text. Inside another
 * interactive reference it renders as plain content. Exists as a component so
 * the plain-function AST renderer can consume the context.
 */
export const CustomerReferenceNode: FC<CustomerReferenceNodeProps> = ({
  className,
  children,
}) => {
  const isInsideInteractiveReference = useIsInsideInteractiveReference();
  if (isInsideInteractiveReference) {
    return <>{children}</>;
  }
  return <span className={className}>{children}</span>;
};
